import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { styled } from "@mui/material/styles";
import FusePageSimple from "@fuse/core/FusePageSimple";
import FuseNavigation from "@fuse/core/FuseNavigation";
import { useThemeMediaQuery } from "@fuse/hooks";
import Card from "@mui/material/Card";
import { motion } from "framer-motion";

const Root: any = styled(FusePageSimple)(({ theme }) => ({
  "& .FusePageSimple-header": {
    backgroundColor: theme.palette.background.paper,
    borderBottomWidth: 1,
    borderStyle: "solid",
    borderColor: theme.palette.divider,
    "& > .container": {
      maxWidth: "100%",
    },
  },
}));

const navigationData = [
  {
    id: "1",
    title: "Reports",
    type: "group",
    children: [
      {
        id: "1",
        title: "Youth Registrations by Program",
        type: "item",
        icon: "heroicons-outline:user-group",
        url: "youth-registrations",
      },
      {
        id: "2",
        title: "Host Registrations by Program",
        type: "item",
        icon: "heroicons-outline:office-building",
        url: "host-registrations",
      },
      {
        id: "3",
        title: "Incentive Report by Program",
        type: "item",
        icon: "heroicons-outline:currency-dollar",
        url: "incentive-report",
      },
      {
        id: "4",
        title: "Average Hourly Rate By Student",
        type: "item",
        icon: "heroicons-outline:clock",
        url: "hourly-rate",
      },
      {
        id: "5",
        title: "Transfer Reports",
        type: "item",
        icon: "heroicons-outline:switch-horizontal",
        url: "transfers",
      },
      {
        id: "6",
        title: "Addressing Concerns",
        type: "item",
        icon: "heroicons-outline:exclamation-circle",
        url: "concerns",
      },
      {
        id: "7",
        title: "Time Management",
        type: "item",
        icon: "heroicons-outline:calendar",
        url: "time-management",
      },
      {
        id: "8",
        title: "Payments to Individuals",
        type: "item",
        icon: "heroicons-outline:cash",
        url: "payments",
      },
    ],
  },
];

export default function AdminReports() {
  const isMobile = useThemeMediaQuery((theme: any) =>
    theme.breakpoints.down("lg")
  );

  const [leftSidebarOpen, setLeftSidebarOpen] = useState(!isMobile);

  useEffect(() => {
    setLeftSidebarOpen(!isMobile);
  }, [isMobile]);

  return (
    <Root
      content={
        <Card variant="outlined" className="m-24 w-full">
          <div className="m-24">
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1, transition: { delay: 0.2 } }}
            >
              <Outlet />
            </motion.div>
          </div>
        </Card>
      }
      leftSidebarContent={
        <div className="px-12 py-24 min-h-6xl">
          <div className="mx-12 text-3xl font-bold tracking-tighter">
            Reports
          </div>
          <FuseNavigation navigation={navigationData} />
        </div>
      }
      leftSidebarOpen={leftSidebarOpen}
      scroll="content"
    />
  );
}
